import { Menu as MenuIcon, Xmark } from 'iconoir-react';
import { FC } from 'react';

import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';
import { cn } from '@savgroup-front-common/primitive/lib/utils';
import { Button } from '@savgroup-front-common/primitive/ui/button';
import { useSidebar } from '@savgroup-front-common/primitive/ui/sidebar';

import messages from './messages';

interface AppBarMenuToggleProps {
  className?: string;
}

export const AppBarMenuToggle: FC<AppBarMenuToggleProps> = ({ className }) => {
  const { isMobile, open, openMobile, toggleSidebar } = useSidebar();
  const isMenuOpen = isMobile ? openMobile : open;

  return (
    <Button
      variant="menu"
      size="icon-sm"
      aria-expanded={isMenuOpen}
      aria-label={
        isMenuOpen
          ? safeFormattedIntlString(messages.closeMenu)
          : safeFormattedIntlString(messages.openMenu)
      }
      data-testid="appBar_menuToggle"
      onClick={toggleSidebar}
      className={cn('ml-2', className)}
    >
      {isMenuOpen ? (
        <Xmark className="size-6" />
      ) : (
        <MenuIcon className="size-6" />
      )}
    </Button>
  );
};
